import redeemVoucherAPI from 'apis/redeemVoucherAPI';
import useAsync from 'hooks/base/useAsync';
import { isNil } from 'lodash';
import React from 'react';
import { message } from 'antd';
// import { useNavigate } from 'react-router-dom';

interface RedeemVoucherParam {
  code: string;
}

const RedeemVoucherPostApi = () => {
  const { status, execute, value } = useAsync(redeemVoucherAPI, false);

  const redeemVoucher = React.useCallback(
    (params: RedeemVoucherParam) => {
      execute(params.code);
    },
    [execute]
  );

  React.useEffect(() => {
    if (isNil(value)) {
      return;
    }

    if (value.error) {
      message.error('Voucher is depleted or expired. Please check your ELSA account or try another voucher');
      return;
    }
  }, [value]);

  return {
    isLoading: status === 'pending',
    redeemVoucher,
    value
  };
};

export default RedeemVoucherPostApi;
